/**
 *
 * AddImage
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ProgressBar } from 'react-bootstrap';
import { mixed } from 'yup';
import DeleteButton from '../../DeleteButton/index.jsx';
import messages from './messages.js';
import useSelectImage from './useSelectImage.jsx';

const PreviewImg = styled.img`
  max-height: 150px;
  min-height: 150px;
  width: 100% ;
  object-fit: cover;
  &.crop-group {
    max-width: 150px;
    min-width: 150px;
    border-radius: 20%;
  }
 `;

function AddImage(props) {
  const { value, crop = 'user', onChange } = props;
  const [preview, setPreview] = useState(value);
  const { selectFiles, progress } = useSelectImage({ crop, onChange, setPreview });

  function handleRemove() {
    setPreview(null);
    onChange(null);
  }

  return (
    <div>
      {preview && (
        <div className="mb-2">
          <PreviewImg src={preview} alt="" className={`crop-${crop}`} />
        </div>
      )}
      <div className="d-flex align-items-baseline mb-3">
        {selectFiles()}
        {preview && (
          <DeleteButton
            className="float-end p-3 ms-3"
            icon="ss-trash fs-2 lower-1"
            onClick={handleRemove}
            confirmText={messages.confirmRemove}
          />
        )}
      </div>
      {progress !== undefined && <ProgressBar now={progress} label={`${progress}%`} />}
    </div>
  );
}

AddImage.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  crop: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

AddImage.getSchema = (options) => {
  const { required } = options;
  return required ? mixed().required() : mixed().nullable();
};
export default AddImage;
